module.exports = __webpack_public_path__ + "static/img/1.8545aea.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/4/zh/1.png
// module id = 0b/6
// module chunks = 0